<script setup lang="ts">
import type { SectionFragment } from '#graphql-operations'

import type { BlocksInterface } from '~/components/organisms/BlocksRenderer.vue'

interface SectionsRendererProps {
  sections?: (SectionFragment | null)[] | null
}

defineProps<SectionsRendererProps>()
</script>

<template>
  <div v-if="sections && sections.length > 0" class="blocks">
    <Section padded class="sectionsList container layout-grid">
      <div class="col-span-full space-y-5 lg:col-span-6 lg:col-start-4">
        <Text as="h4" :text="$t('in_this_article')" class="typo-sans-2 uppercase" />
        <ul class="pl-6 list-disc">
          <li v-for="section in sections " :key="section!.id" class="typo-serif-2">
            <NuxtLink :to="`#${section!.slug}`" :title="section?.title" class="motion-snug @hover:opacity-40">
              {{ section?.title }}
            </NuxtLink>
          </li>
        </ul>
      </div>
    </Section>
    <BlocksRenderer v-for="section in sections" :id="section!.slug" :key="section!.id" :blocks="(section?.blocks as BlocksInterface[])" />
  </div>
</template>

<style scoped>
.blocks :deep(.sectionsList:has(+ .blocks > .section.blockTextFlow:first-child)) {
  margin-bottom: calc(var(--spacing) * 9);
}

.blocks :deep(.sectionsList + .blocks > .section.blockTextFlow:first-child) {
  margin-top: calc(var(--spacing) * 9);
}
</style>
